export { default } from './KarmaMedal'
